import React from 'react';
import PropTypes from 'prop-types';

export default function DashboardIcon(props) {
  const { fill, width, height, className } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 19.509 15.962'
      className={className}
    >
      <path
        id='ic_dvr_24px'
        d='M18.736,3H2.774A1.779,1.779,0,0,0,1,4.774V15.415a1.779,1.779,0,0,0,1.774,1.774H7.208v1.774H14.3V17.189h4.434A1.771,1.771,0,0,0,20.5,15.415l.009-10.641A1.779,1.779,0,0,0,18.736,3Zm0,12.415H2.774V4.774H18.736ZM16.962,7.434H7.208V9.208h9.755Zm0,3.547H7.208v1.774h9.755ZM6.321,7.434H4.547V9.208H6.321Zm0,3.547H4.547v1.774H6.321Z'
        transform='translate(-1 -3)'
        fill={fill}
      />
    </svg>
  );
}

DashboardIcon.defaultProps = {
  fill: '#cacaca',
  width: 19.509,
  height: 15.962
};

DashboardIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};
